export default "__VITE_ASSET__D0_c1ToZ__"